import React from 'react';
import "../../styles/Login.css";

export default function FooterLogin() {
  return (
    <div className="footer bar-header-footer">
      <div className="container-box">
        <p className="text">
          Si eres nuevo y quieres registrarte, descarga nuestra app móvil y sé parte de Mercanteomexico.
        </p>
      </div>
    </div>
  );
}
